import script from "./phonesignUp.vue?vue&type=script&setup=true&lang=js"
export * from "./phonesignUp.vue?vue&type=script&setup=true&lang=js"

import "./phonesignUp.vue?vue&type=style&index=0&id=07b7f0a5&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b7f0a5"]])

export default __exports__